/* ===== MIELI MELLOW - ANIMATIONS PREMIUM ===== */
(function() {
  'use strict';

  function initMieliAnimations() {
    var cards = document.querySelectorAll('.article-card, .card--article, [class*="article"]');
    var images = document.querySelectorAll('.card__media, .card__image-wrapper');

    cards.forEach(function(card) { card.classList.add('mieli-fade-up'); });
    images.forEach(function(img) { img.classList.add('mieli-img-wrap'); });

    document.querySelectorAll('a[href*="/blogs/"]').forEach(function(link) {
      var text = link.textContent.trim().toLowerCase();
      if (text.includes('lire') || text.includes('suite') || text.includes('read')) {
        link.classList.add('mieli-read-more');
      }
    });

    var staggerIndex = 0;
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var delay = (staggerIndex % 4) * 100;
          staggerIndex++;
          setTimeout(function() {
            entry.target.classList.add('is-visible');
          }, delay);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.mieli-fade-up, .mieli-img-wrap').forEach(function(el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMieliAnimations);
  } else {
    initMieliAnimations();
  }
})();
